import styled from 'styled-components';

export const Actions = styled.footer`
  justify-content: space-between!important;

  div > * {
    margin-right: 0.7rem;
  }
`;
